import {
    Box,
    Paper,
    Typography,
    Chip,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/Filter';

const selectSx = {
    color: '#fff',
    '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(59, 130, 246, 0.3)' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(59, 130, 246, 0.5)' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
    '.MuiSvgIcon-root': { color: '#93c5fd' },
};

// Filterleiste für die Highscore-Übersicht.
function HighscoreFilter({
    selectedZielmuskel,
    onZielmuskel,
    selectedNutzer,
    onNutzer,
    zielmuskeln,
    nutzerListe,
    onReset,
    resultCount,
}) {
    return (
        <Paper
            sx={{
                p: 2,
                mb: 3,
                background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
                border: "1px solid rgba(59, 130, 246, 0.2)",
                borderRadius: "16px"
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <FilterListIcon sx={{ color: '#3b82f6', mr: 1 }} />
                <Typography variant="h6" color="#e0f2fe" fontWeight={600}>
                    Filter
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid>
                    <FormControl fullWidth size="small">
                        <InputLabel sx={{ color: '#93c5fd' }}>Zielmuskel</InputLabel>
                        <Select
                            value={selectedZielmuskel}
                            label="Zielmuskel"
                            onChange={(e) => onZielmuskel(e.target.value)}
                            sx={selectSx}
                        >
                            <MenuItem value="alle">Alle Muskeln</MenuItem>
                            {zielmuskeln.map((muskel) => (
                                <MenuItem key={muskel} value={muskel}>
                                    {muskel}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid>
                    <FormControl fullWidth size="small">
                        <InputLabel sx={{ color: '#93c5fd' }}>Nutzer</InputLabel>
                        <Select
                            value={selectedNutzer}
                            label="Nutzer"
                            onChange={(e) => onNutzer(e.target.value)}
                            sx={selectSx}
                        >
                            <MenuItem value="alle">Alle Nutzer</MenuItem>
                            {nutzerListe.map((nutzerName) => (
                                <MenuItem key={nutzerName} value={nutzerName}>
                                    {nutzerName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid>
                    <Box sx={{ display: 'flex', gap: 1, height: '100%', alignItems: 'center' }}>
                        <Chip
                            label="Filter zurücksetzen"
                            onClick={onReset}
                            sx={{
                                backgroundColor: '#1e3a8a',
                                color: '#e0f2fe',
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#3b82f6' },
                            }}
                        />
                        <Chip
                            label={`${resultCount} Ergebnisse`}
                            sx={{
                                backgroundColor: 'rgba(59, 130, 246, 0.2)',
                                color: '#3b82f6',
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default HighscoreFilter;
